export const SET_REPORT_FILTER = 'SET_REPORT_FILTER'

export function setReportFilter(filter) {
    return {
      type: SET_REPORT_FILTER,
      payload: filter,
    }
  }